module.exports = __webpack_public_path__ + "img/collaborate-rules-introduce.672ad34f.png";